import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-payments',
  templateUrl: './web-payments.component.html',
  styleUrls: ['./web-payments.component.scss']
})
export class WebPaymentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/web-payments/web-payments.component.ts